import { useEffect, useState } from "react";
import { Table } from "@dealer-center/core-components";
import type { indexMappingKeys, indexMappingString } from "./tabs/helper";
import {
  getIndexMappingString,
  getIndexMappingValue,
  indexMapping
} from "./tabs/helper";
import type { RouteObject } from "react-router-dom";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import PagesAutoDataTabs from "./tabs/tabs";
import { columns } from "./helper";
import { useGetAutoDataVehicle } from "@dealer-center/ddc-pages-vin-decode-fetch";
import type { vehicleInterface } from "@dealer-center/ddc-pages-vin-decode-interface";
import type {
  InterstateOnChangeEvent,
  TextInputEventValue
} from "@dealer-center/core-components";
import { SelectInput, VinInput } from "@dealer-center/core-components";

const pageSize = 50;
interface vehicleInterfaceWithKey extends vehicleInterface {
  key: number;
}
export const route = [
  {
    path: "vin-decode/:country?/:vin?/:trim?/:tab?",
    element: <PagesAutoData />
  },
  {
    path: "autodata/*",
    element: <Navigate replace to="/vin-decode/" />
  }
] as RouteObject[];
export function PagesAutoData() {
  const navigate = useNavigate();
  const {
    country: countryParam,
    vin: vinParam,
    trim: trimParam,
    tab: tabParam
  } = useParams();
  const { data: listOfTrims } = useGetAutoDataVehicle(
    vinParam,
    countryParam as "US" | "CA"
  );

  useEffect(() => {
    document.title = "VIN Decode";
  }, []);
  const [vin, setVin] = useState(vinParam || "");
  const [country, setCountry] = useState<"US" | "CA">(
    (countryParam as "US" | "CA") || "US"
  );
  const [isValueValid, setIsValueValid] = useState(true);
  const [selectedTrim, setSelectedTrim] = useState<string | undefined>(
    trimParam || undefined
  );

  const [selectedTab, setSelectedTab] = useState<indexMappingKeys>(
    getIndexMappingValue(tabParam as indexMappingString) || indexMapping.options
  );
  useEffect(() => {
    if (vin !== vinParam || country !== countryParam)
      setSelectedTrim(undefined);
    if (!isValueValid || !vin || !country) {
      navigate("/vin-decode/");
      return;
    }
    if (selectedTrim) {
      const tab = getIndexMappingString(selectedTab || indexMapping.options);
      navigate(`/vin-decode/${country}/${vin}/${selectedTrim}/${tab}`);
    } else {
      navigate(`/vin-decode/${country}/${vin}`);
    }
  }, [
    vin,
    country,
    selectedTrim,
    selectedTab,
    vinParam,
    countryParam,
    isValueValid,
    navigate
  ]);
  const onInputChange = async (
    interstateEvent: InterstateOnChangeEvent<TextInputEventValue>
  ) => {
    const currentValue = interstateEvent.target.value;
    const isValid =
      (interstateEvent.isValid &&
        currentValue.replace(/_/g, "").length === 17) ||
      false;
    setIsValueValid(isValid);
    const vin = currentValue;
    if (typeof vin !== "string") return;
    setVin(vin.trim());
  };

  const onClickRow = (record: vehicleInterface) => ({
    onClick: () => {
      const _selectedTrim = record.vehicleId;
      setSelectedTrim(_selectedTrim);
      navigate(`/vin-decode/${country}/${vin}/${_selectedTrim}`);
    }
  });
  /// add a key prop to each record
  const listOfTrimsWithKey: vehicleInterfaceWithKey[] | undefined =
    listOfTrims?.map((record, index) => ({ ...record, key: index }));
  return (
    <>
      <h1>VIN Decode</h1>
      <VinInput
        autoFocus
        inputPrefix={
          <SelectInput
            data-testid="country-input"
            displayLabel={false}
            label="Select Country"
            name="CountryInput"
            options={[
              {
                disabled: false,
                label: "🇺🇸",
                value: "US"
              },
              {
                disabled: false,
                label: "🇨🇦",
                value: "CA"
              }
            ]}
            size="sm"
            sx={{ "max-width": "4vw" }}
            value={country}
            onChange={event => {
              if (event.isValid) {
                setCountry(event.target.value as "US" | "CA");
              }
            }}
          />
        }
        label="VIN"
        name="VinInputOptional"
        placeholder="Enter VIN"
        value={vin}
        onChange={onInputChange}
      />
      <Table.Table
        columns={columns}
        currentPageSize={pageSize}
        data={listOfTrimsWithKey || []}
        displayPageSizeSelector={false}
        enablePagination={
          listOfTrims && listOfTrims.length > pageSize ? true : false
        }
        style={{ cursor: "pointer" }}
        onRowCallback={onClickRow}
      />
      <PagesAutoDataTabs
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
    </>
  );
}

export default PagesAutoData;
